import getData from "@/__main__/get-data.mjs";
import type { FortniteSeasons } from "@/game-fortnite/models/season.mjs";
import FortniteSeasonsModel from "@/game-fortnite/models/season.mjs";
import * as API from "@/game-fortnite/utils/api.mjs";

function fetchSeasons(skipSafetyCheck = false): Promise<FortniteSeasons> {
  return getData(
    API.getSeasons(),
    FortniteSeasonsModel,
    ["fortnite", "seasons"],
    {
      skipSafetyCheck,
    },
  );
}

export default fetchSeasons;
